/** CEO drill-down metric ids — must match server ceoDetailService VALID_METRICS */

export const CEO_PERIOD_STORAGE_KEY = 'ceoReportingPeriod';

/** @param {string | null | undefined} value */
export function parseCeoPeriod(value) {
  return String(value || '').toUpperCase() === 'MONTH' ? 'MONTH' : 'WEEK';
}

/** @param {string} [period] */
export function buildCeoDashboardUrl(period = 'WEEK') {
  return `/ceo?period=${parseCeoPeriod(period)}`;
}

export const CEO_METRICS = {
  ENQUIRIES: 'enquiries',
  ENQUIRIES_LEADS: 'enquiries-leads',
  ENQUIRIES_OPPORTUNITIES: 'enquiries-opportunities',
  PROPERTIES_BOOKED: 'properties-booked',
  NEW_ON_WEBSITE: 'new-on-website',
  DELISTINGS: 'delistings',
  CLOSED_WON: 'closed-won',
  CLOSED_LOST: 'closed-lost',
  REVENUE: 'revenue',
  AVG_BOOKING_VALUE: 'avg-booking-value',
  ENQUIRY_CATEGORIES: 'enquiry-categories',
  LEAD_CATEGORIES: 'lead-categories',
  OPPORTUNITY_SECTORS: 'opportunity-sectors',
  CLOSED_WON_SECTOR: 'closed-won-sector',
  CLOSED_LOST_REASONS: 'closed-lost-reasons',
  CLOSED_LOST_STATES: 'closed-lost-states',
  CONVERSION_BY_SECTOR: 'conversion-by-sector',
  AVG_BOOKING_BY_SECTOR: 'avg-booking-by-sector',
  AVG_BOOKING_BY_BRAND: 'avg-booking-by-brand',
  PIPELINE_OPEN: 'pipeline-open',
  ENQUIRY_FUNNEL: 'enquiry-funnel',
};

/**
 * @param {{ metric: string, period?: string, window?: string, stage?: string, group?: string }} opts
 */
export function buildCeoDetailUrl({ metric, period = 'WEEK', window = 'current', stage, group, startDate, endDate }) {
  const params = new URLSearchParams();
  if (startDate && endDate) {
    params.set('startDate', startDate);
    params.set('endDate', endDate);
  } else {
    params.set('period', parseCeoPeriod(period));
  }
  params.set('window', window === 'previous' ? 'previous' : 'current');
  if (stage) params.set('stage', stage);
  if (group != null && group !== '') params.set('group', group);
  const qs = params.toString();
  return `/ceo/detail/${encodeURIComponent(metric)}${qs ? `?${qs}` : ''}`;
}
